import { Enum  } from "./Enum";

export const OrderPaymentStatusEnum: Enum[] = [
  { id: 'requires_payment_method', name: 'Requires Payment Method' },
  { id: 'requires_confirmation', name: 'Requires Confirmation' },
  { id: 'requires_action', name: 'Requires Action' },
  { id: 'processing', name: 'Processing' },
  { id: 'requires_capture', name: 'Requires Capture' },
  { id: 'canceled', name: 'Canceled' },
  { id: 'succeeded', name: 'Succeeded' }
];
